import { createFileRoute } from '@tanstack/react-router';
import { UsersSettingsPage } from '../features/settings/access/UsersSettingsPage';

export const Route = createFileRoute('/settings/users')({
  component: UsersSettingsPage,
});
